export default {
    "name": "DeleteItinerariesFavorite",
    "kind": "HoudiniMutation",
    "hash": "30cb443b92dc0fd9fdfe73fdf266b1c20cd6e80ea60236fdb123c3cefbb51e46",

    "raw": `mutation DeleteItinerariesFavorite($input: DeleteItinerariesFavoriteInput!) {
  deleteItinerariesFavorite(input: $input) {
    itinerariesFavorites {
      coordinates {
        lat
        lng
      }
      mode
      currency
      distanceSystem
      departureName
      arrivalName
      steps
      isEv
      withCaravan
      constraints
      duration
      distance {
        value
        unit
      }
      totalCost {
        amount
        currency
      }
      timestamp
      carId
    }
  }
}`,

    "rootType": "Mutation",
    "stripVariables": [],

    "selection": {
        "fields": {
            "deleteItinerariesFavorite": {
                "type": "User",
                "keyRaw": "deleteItinerariesFavorite(input: $input)",

                "selection": {
                    "fields": {
                        "itinerariesFavorites": {
                            "type": "ItineraryFavorite",
                            "keyRaw": "itinerariesFavorites",

                            "selection": {
                                "fields": {
                                    "coordinates": {
                                        "type": "Coordinates",
                                        "keyRaw": "coordinates",

                                        "selection": {
                                            "fields": {
                                                "lat": {
                                                    "type": "Float",
                                                    "keyRaw": "lat",
                                                    "visible": true
                                                },

                                                "lng": {
                                                    "type": "Float",
                                                    "keyRaw": "lng",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "mode": {
                                        "type": "ItineraryTravelMode",
                                        "keyRaw": "mode",
                                        "visible": true
                                    },

                                    "currency": {
                                        "type": "Currency",
                                        "keyRaw": "currency",
                                        "visible": true
                                    },

                                    "distanceSystem": {
                                        "type": "DistanceSystem",
                                        "keyRaw": "distanceSystem",
                                        "visible": true
                                    },

                                    "departureName": {
                                        "type": "String",
                                        "keyRaw": "departureName",
                                        "visible": true
                                    },

                                    "arrivalName": {
                                        "type": "String",
                                        "keyRaw": "arrivalName",
                                        "visible": true
                                    },

                                    "steps": {
                                        "type": "String",
                                        "keyRaw": "steps",
                                        "visible": true
                                    },

                                    "isEv": {
                                        "type": "Boolean",
                                        "keyRaw": "isEv",
                                        "visible": true
                                    },

                                    "withCaravan": {
                                        "type": "Boolean",
                                        "keyRaw": "withCaravan",
                                        "visible": true
                                    },

                                    "constraints": {
                                        "type": "ItineraryConstraint",
                                        "keyRaw": "constraints",
                                        "visible": true
                                    },

                                    "duration": {
                                        "type": "Int",
                                        "keyRaw": "duration",
                                        "visible": true
                                    },

                                    "distance": {
                                        "type": "Distance",
                                        "keyRaw": "distance",

                                        "selection": {
                                            "fields": {
                                                "value": {
                                                    "type": "Float",
                                                    "keyRaw": "value",
                                                    "visible": true
                                                },

                                                "unit": {
                                                    "type": "DistanceUnit",
                                                    "keyRaw": "unit",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "totalCost": {
                                        "type": "Price",
                                        "keyRaw": "totalCost",

                                        "selection": {
                                            "fields": {
                                                "amount": {
                                                    "type": "Float",
                                                    "keyRaw": "amount",
                                                    "visible": true
                                                },

                                                "currency": {
                                                    "type": "String",
                                                    "keyRaw": "currency",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "timestamp": {
                                        "type": "Float",
                                        "keyRaw": "timestamp",
                                        "visible": true
                                    },

                                    "carId": {
                                        "type": "String",
                                        "keyRaw": "carId",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "input": "DeleteItinerariesFavoriteInput"
        },

        "types": {
            "DeleteItinerariesFavoriteInput": {
                "timestamp": "Float"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    }
};

"HoudiniHash=76cbe6d3cc5ecc19bb057a76e6ded1ecab8380273da7fe03dae41f202221bd78";